import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';

export function AdminLayout() {
  return (
    <div className="flex h-[calc(100vh-4rem)] relative overflow-hidden">
      <div className="w-64 border-r border-gray-200 dark:border-gray-700 absolute md:relative">
        <AdminSidebar />
      </div>
      <div className="flex-1 overflow-auto w-full">
        <Outlet />
      </div>
    </div>
  );
}